import { AreasOfExpertise, Professions } from "@bonliva-crm/shared";
import { ConsultantEditorStore } from "../ConsultantEditorStore";
import { ExpertiseProfessionStore } from "./ExpertiseProfessionStore";
import { OnlyExperienceStore } from "./OnlyExperience/OnlyExperienceStore";
import { DoctorStore } from "./Doctor/DoctorStore";
import { TeacherStore } from "./Teacher/TeacherStore";
import { RadiographersStore } from "./Radiographers/RadiographersStore";
import { SocionomStore } from "./Socionom/SocionomStore";
import { SSKStore } from "./SSK/SSKStore";

export function createProfessionStore(
  profession: string,
  professionIndex: number,
  editorStore: ConsultantEditorStore
) {
  let profStore: ExpertiseProfessionStore | null = null;

  switch (profession) {
    case Professions.SE_ARBETSTERAPEUT:
      profStore = new OnlyExperienceStore(profession, professionIndex, editorStore);
      break;

    case Professions.SE_AUDIONOM:
      profStore = new OnlyExperienceStore(profession, professionIndex, editorStore);
      break;

    case Professions.SE_BARNMORSKA:
      profStore = new OnlyExperienceStore(profession, professionIndex, editorStore);
      break;

    case Professions.SE_BIOMEDICINSK_ANALYTIKER:
      profStore = new OnlyExperienceStore(profession, professionIndex, editorStore);
      break;

    case Professions.SE_DIETIST:
      profStore = new OnlyExperienceStore(profession, professionIndex, editorStore);
      break;

    case Professions.SE_FARMACEUTER:
      profStore = new OnlyExperienceStore(profession, professionIndex, editorStore);
      break;

    case Professions.SE_FYSIOTERAPEUT:
      profStore = new OnlyExperienceStore(profession, professionIndex, editorStore);
      break;

    case Professions.SE_HALSO_OCH_SJUKVARDKURATOR:
      profStore = new OnlyExperienceStore(profession, professionIndex, editorStore);
      break;

    case Professions.SE_INTERNREKRYTERING:
      profStore = new OnlyExperienceStore(profession, professionIndex, editorStore);
      break;

    case Professions.SE_LAKARE:
      profStore = new DoctorStore(
        profession,
        AreasOfExpertise.SE_LAKARE.DEFAULT,
        professionIndex,
        editorStore
      );
      break;

    case Professions.SE_LARARE:
      profStore = new TeacherStore(professionIndex, editorStore);
      break;

    case Professions.SE_MEDICINSKA_SEKRETERARE:
      profStore = new OnlyExperienceStore(profession, professionIndex, editorStore);
      break;

    case Professions.SE_PSYKOLOG:
      profStore = new OnlyExperienceStore(profession, professionIndex, editorStore);
      break;

    case Professions.SE_PSYKOTERAPEUT:
      profStore = new OnlyExperienceStore(profession, professionIndex, editorStore);
      break;

    case Professions.SE_RONTGENSJUKSKOTERSKA:
      profStore = new RadiographersStore(
        Professions.SE_RONTGENSJUKSKOTERSKA,
        professionIndex,
        editorStore
      );
      break;

    case Professions.SE_SOCIONOM:
      profStore = new SocionomStore(
        Professions.SE_SOCIONOM,
        professionIndex,
        editorStore
      );
      break;

    case Professions.SE_SSK:
      profStore = new SSKStore(
        Professions.SE_SSK,
        professionIndex,
        editorStore,
        AreasOfExpertise.SE_SSK.DEFAULT
      );
      break;

    case Professions.SE_USK:
      profStore = new OnlyExperienceStore(profession, professionIndex, editorStore);
      break;

    case Professions.NO_LEGE:
      profStore = new DoctorStore(
        profession,
        AreasOfExpertise.NO_LEGE.DEFAULT,
        professionIndex,
        editorStore
      );
      break;

    case Professions.NO_SYKEPLEIE:
      profStore = new SSKStore(
        Professions.NO_SYKEPLEIE,
        professionIndex,
        editorStore,
        null
      );
      break;

    case Professions.DK_JORDEMODER:
      profStore = new OnlyExperienceStore(
        Professions.DK_JORDEMODER,
        professionIndex,
        editorStore
      );
      break;

    case Professions.DK_LAEGER:
      profStore = new DoctorStore(profession, "", professionIndex, editorStore);
      break;

    case Professions.DK_RADIOGRAFER:
      profStore = new RadiographersStore(
        Professions.DK_RADIOGRAFER,
        professionIndex,
        editorStore
      );
      break;

    case Professions.DK_SOCIAL_OG_SUNDHEDSASSISTENT:
      profStore = new RadiographersStore(
        Professions.DK_SOCIAL_OG_SUNDHEDSASSISTENT,
        professionIndex,
        editorStore
      );
      break;

    case Professions.DK_SYGEPLEJERSKER:
      profStore = new SSKStore(
        Professions.DK_SYGEPLEJERSKER,
        professionIndex,
        editorStore,
        null
      );
      break;

    case Professions.DK_SOCIALPAEDAGOG:
      profStore = new OnlyExperienceStore(
        Professions.DK_SOCIALPAEDAGOG,
        professionIndex,
        editorStore
      );
      break;

    case Professions.DK_HJAELPEPLEJER:
      profStore = new OnlyExperienceStore(
        Professions.DK_HJAELPEPLEJER,
        professionIndex,
        editorStore
      );
      break;

    case Professions.DK_FAMILJEBEHANDLARE:
      profStore = new OnlyExperienceStore(
        Professions.DK_FAMILJEBEHANDLARE,
        professionIndex,
        editorStore
      );
      break;

    case Professions.DK_SOCIAL_OG_SUNDHEDSHJAELPER:
      profStore = new OnlyExperienceStore(
        Professions.DK_SOCIAL_OG_SUNDHEDSHJAELPER,
        professionIndex,
        editorStore
      );
      break;

    case Professions.DK_PLEJER:
      profStore = new OnlyExperienceStore(
        Professions.DK_PLEJER,
        professionIndex,
        editorStore
      );
      break;

    case Professions.DK_SYGEHJAELPER:
      profStore = new OnlyExperienceStore(
        Professions.DK_SYGEHJAELPER,
        professionIndex,
        editorStore
      );
      break;

    case Professions.DK_OMSORGSMEDARBEJDER:
      profStore = new OnlyExperienceStore(
        Professions.DK_OMSORGSMEDARBEJDER,
        professionIndex,
        editorStore
      );
      break;

    case Professions.DK_PSYKIATRIMEDARBEJDER:
      profStore = new OnlyExperienceStore(
        Professions.DK_PSYKIATRIMEDARBEJDER,
        professionIndex,
        editorStore
      );
      break;

    case Professions.DK_TERAPEUT:
      profStore = new OnlyExperienceStore(
        Professions.DK_TERAPEUT,
        professionIndex,
        editorStore
      );
      break;

    case Professions.DK_PAEDAGOGISK_ASSISTENT:
      profStore = new OnlyExperienceStore(
        Professions.DK_PAEDAGOGISK_ASSISTENT,
        professionIndex,
        editorStore
      );
      break;

    case Professions.DK_SOCIALRAADGIVER:
      profStore = new OnlyExperienceStore(
        Professions.DK_SOCIALRAADGIVER,
        professionIndex,
        editorStore
      );
      break;

    case Professions.DK_ERGOTERAPEUT:
      profStore = new OnlyExperienceStore(
        Professions.DK_ERGOTERAPEUT,
        professionIndex,
        editorStore
      );
      break;

    case Professions.DK_PAEDAGOGMEDHJAELPER:
      profStore = new OnlyExperienceStore(
        Professions.DK_PAEDAGOGMEDHJAELPER,
        professionIndex,
        editorStore
      );
      break;

    case Professions.FI_LAAKARI:
      profStore = new DoctorStore(profession, "", professionIndex, editorStore);
      break;

    case Professions.FI_SAIRAANHOITAJA:
      profStore = new SSKStore(
        Professions.FI_SAIRAANHOITAJA,
        professionIndex,
        editorStore,
        null
      );
      break;

    default:
      profStore = null;
  }

  if (profStore) {
    editorStore.addProfessionStore(profession, profStore);
  }

  profStore.initForm();
  profStore.initialSetup();

  return profStore;
}
